import { render } from "./GrossRevenueChart.vue?vue&type=template&id=22d6394a&ts=true"
import script from "./GrossRevenueChart.vue?vue&type=script&lang=ts"
export * from "./GrossRevenueChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__